module.exports = "<div class=\"sort-dropdown\">\r\n  <button class=\"sort-toggle\" (click)=\"toggleDropdown()\">\r\n    <em class=\"fa fa-chevron-down\"></em>\r\n  </button>\r\n\r\n  <div class=\"dropdown-menu\" *ngIf=\"isOpen\">\r\n    <button (click)=\"selectOrder('asc')\"><em class=\"fa fa-sort-up\"></em> Ascending</button>\r\n    <button (click)=\"selectOrder('desc')\"><em class=\"fa fa-sort-down\"></em> Descending</button>\r\n    <button (click)=\"selectOrder('reset')\"><em class=\"fa fa-undo\"></em> Reset</button>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sort-dropdown/sort-dropdown.component.html
// module id = 1028
// module chunks = 1